import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=7d147c7b"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d147c7b')) {
      api.createRecord('7d147c7b', component.options)
    } else {
      api.reload('7d147c7b', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=7d147c7b", function () {
      api.rerender('7d147c7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/cadastros/motivospendenciaauditoria/Form.vue"
export default component.exports